// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list"}[chunkId] || chunkId) + "-" + {"273":"31e62301821be174acc2","702":"294142c04b48ebb6dce6","715":"4385524990ea6da93505"}[chunkId] + ".css";
};